import { Injectable } from '@angular/core';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';

@Injectable()
export class CompanyConfigService {
  protected path = 'website/companyconfig';
  constructor(
    private httpService: HttpService,
    private appConfigService: AppConfigService,

    ) {}

  public getCompanyConfig(): Observable<void> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if(this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makeGet<void>(this.path,  null, null, {'CompanyGuid': companyGUID});
  }
}
